<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import categoryApi from '../../services/branch-categories/branch-category.api'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showEdit(e, cell) {
      this.$router.push({
        name: 'superadmin-tools-category-edit',
        params: {
          uuid: cell.getData().uuid,
          lang: cell.getColumn().getDefinition().field.substring(7)
        }
      })
    },
    formatDate(date) {
      const d = new Date(date)
      return (
        d.toISOString().replace(/^(\d+)-(\d+)-(\d+).*$/, '$3.$2.$1') +
        ' ' +
        d.toLocaleTimeString().replace(/^(\d+):(\d+):\d+$/, '$1:$2')
      )
    },
    editFormatter(cell) {
      let lang = cell.getColumn().getDefinition().field.substring(10)
      if (lang === 'US') {
        lang = 'gb'
      }
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action" title="' +
        lang.toUpperCase() +
        '">' +
        '<span data-v-60be6971="" class="flag f-' +
        lang.toLowerCase() +
        ' small-flag"></span></button></div>'
      )
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function (url, config, params) {
        return categoryApi.getList(params.page, params.size)
      },
      ajaxResponse: function (url, params, response) {
        return response.data.data
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.title'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          headerSort: false,
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${cell.getData().title}</div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'action-sk_SK',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'action-en_US',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'action-cs_CZ',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'action-de_DE',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'action-pl_PL',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        }
      ]
    })
  }
})
</script>
